import {ReactNode} from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
}

const Card = ({children, className = ''}: CardProps) => (
  <div className={`bg-white rounded-lg shadow-sm border border-gray-200 ${className}`}>
    {children}
  </div>
);

export default Card;
